import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

import { ButtonLink, Icon, LogoSvg, Button } from '@/components/ui';

import {
	setAuthorizationStatus,
	setShowTariffsGuestPopup,
} from '@/stores/slices/popupSlice';
import { setAuthorisationAccessType } from '@/stores/slices/popupSlice';

import './footer.scss';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	getCountrySlug,
	getCurrentLinkCity,
	getUserCurrentCity,
	getUserCurrentDistrict,
} from '@/stores/slices/userSlice';
import { getDisabledFilters } from '@/stores/slices/filterSlice';
import useLadyService from '@/services/LadyService';
import { useTranslation } from 'react-i18next';
import { getUserRegion } from '@/stores/slices/userSlice';

import solana from '@/assets/img/icons/solana.svg';
import { useFilterLogicContext } from '../filter/FilterLogicProvider';
import { useToggleCountryCZ } from '../ui/select/SelectCountry';

const paymentsMethods = [
	{ icon: 'visa', name: 'Visa' },
	{ icon: 'master-card', name: 'MasterCard' },
	{ icon: 'american-express', name: 'AmericanExpress' },
	{ icon: 'paypal', name: 'PayPal' },
	{ icon: 'google-pay', name: 'Google Pay' },
	{ icon: 'apple-pay', name: 'Apple Pay' },
	// {icon: "union-pay", name: "Union Pay"},
	{ icon: 'bitcoin', name: 'Bitcoin' },
	{ icon: 'tether', name: 'Tether' },
	{ icon: 'usdc', name: 'USDC' },
	{ icon: 'etherium', name: 'Ethereum' },
	{ icon: 'ltc', name: 'Litecoin' },
	{ icon: 'tron', name: 'Tron' },
];

const Pixel = () => {
	return (
		<>
			<script type="text/javascript">
				// Insert Twitter Event ID twq('event', 'tw-plw5j-prlwf', {});
			</script>
		</>
	);
};

const Footer = () => {
	const { userType, lang, scrollToTop } = useLadyService();

	const location = useLocation();
	const params = useParams();
	const dispatch = useDispatch();
	const region = useSelector(getUserRegion);
	const { t } = useTranslation('translation');
	const navigate = useNavigate();
	const FILTER = useFilterLogicContext();

	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');

	// twitter pixel
	// useEffect(() => {
	// 	const script = document.createElement('script');
	// 	script.type = 'text/javascript';

	// 	script.innerHTML = `twq('event', 'tw-plw5j-prlwf', {});`;

	// 	document.body.appendChild(script);

	// 	return () => {
	// 		document.body.removeChild(script);
	// 	};
	// }, []);

	const cityCurrent = useSelector(getUserCurrentCity);
	const currentLinksCity = useSelector(getCurrentLinkCity);
	const disabledFilters = useSelector(getDisabledFilters);

	const baseCitySlug = currentLinksCity?.slug ?? cityCurrent?.slug;
	const isAgencyPage =
		location.pathname.includes('agency') ||
		location.pathname.includes('agencies');

	// Derived value only: do not mutate local variables inside useEffect.
	const city = isAgencyPage ? 'czechia' : baseCitySlug;

	const postTitleFooter = t('titlefooter', {
		City: cityCurrent?.title ?? '',

		Country: region,
	});

	const disabledSet = useMemo(
		() => new Set(disabledFilters),
		[disabledFilters],
	);

	const categoryLinks = useMemo(
		() => [
			{
				id: 1,
				link: `/indi`,
				title: t('indi'),
				name: 'status',
				disabled: disabledSet.has('statusIndividual'),
			},
			{
				id: 2,
				link: `/elitelady`,
				title: t('elite'),
				name: 'status',
				disabled: disabledSet.has('statusElite'),
			},
			{
				id: 3,
				link: `/pornstar`,
				title: t('star'),
				name: 'status',
				disabled: disabledSet.has('statusPornstar'),
			},
			{
				id: 4,
				link: `/online`,
				title: t('online'),
				name: 'status',
				disabled: disabledSet.has('statusOnline'),
			},
			{
				id: 8,
				link: `/new`,
				title: t('newmodels'),
				name: 'status',
				disabled: disabledSet.has('statusNew'),
			},
			{
				id: 11,
				link: `/bdsm`,
				title: t('bdsm'),
				name: 'status',
				disabled: disabledSet.has('statusBDSM'),
			},
			{
				id: 10,
				link: `/couple`,
				title: t('couples'),
				name: 'status',
				disabled: disabledSet.has('genderCouple'),
			},
			{
				id: 12,
				link: `/trans`,
				title: t('trans'),
				name: 'gender',
				disabled: disabledSet.has('genderTrans'),
			},
			{
				id: 13,
				link: `/guys`,
				title: t('guys'),
				name: 'gender',
				disabled: disabledSet.has('genderMale'),
			},
			{
				id: 5,
				link: `/vchat`,
				title: t('videochat'),
				name: 'status',
				disabled: disabledSet.has('tagVideochat'),
			},
			{
				id: 55,
				link: `/ero`,
				title: t('erocontent'),
				name: 'status',
				disabled: disabledSet.has('tagEro'),
			},
			{
				id: 6,
				link: `/verified`,
				title: t('verified'),
				name: 'status',
				disabled: disabledSet.has('statusVerification'),
			},
			{
				id: 7,
				link: `/healthy`,
				title: t('healthy'),
				name: 'status',
				disabled: disabledSet.has('statusHealthControl'),
			},
			{
				id: 200,
				link: `/anal`,
				title: t('anal-sex'),
				name: 'services',
				disabled: disabledSet.has('statusAnal'),
			},
			{
				id: 201,
				title: t('asiatag'),
				name: 'nation',
				link: `/asian`,
				disabled: disabledSet.has('statusAsian'),
			},
			{
				id: 'hairBlond',
				title: t('blondes'),
				name: 'hair_color',
				value: 'blond',
				link: '/blondes',
				checked: false,
				disabled: disabledSet.has('statusBlond'),
				translateKey: 'blondes',
			},
			{
				id: 8,
				link: '/massage',
				title: t('eromassage'),
				disabled: disabledSet.has('statusMassage'),
			},
		],
		[disabledSet, lang, city],
	);

	const supportLink = useMemo(() => {
		return {
			id: 501,
			link: `/${lang}/lk/support`,
			name: t('support'),
		};
	}, [lang]);

	const mainUrl = useMemo(() => {
		let url = `/${lang}/czechia`;
		if (lang === 'en') {
			url = '/';
		}
		if (isJsdom) {
			if (lang === 'en') {
				url = '/';
			} else {
				url = `/${lang}/czechia`;
			}
		}

		return url;
	}, [lang, isJsdom]);

	const infoLinks = useMemo(() => {
		return {
			top_links: [
				{
					id: 101,
					link: mainUrl,
					name: t('mainpage'),
					icon: 'home-main',
				},
				{ id: 201, link: `/${lang}/about`, name: t('about') },
				{ id: 301, link: `/${lang}/guide`, name: t('guide') },
				{ id: 401, link: `/${lang}/blog`, name: t('blog') },
				...(isJsdom ? [] : [supportLink]),
				{
					id: 501,
					link: `/${lang}/about#about-portaloperator`,
					name: t('contacts'),
				},
			],

			bottom_links: [
				{ id: 102, link: `/${lang}/rules`, name: t('termsofservice') },
				{ id: 202, link: `/${lang}/gdpr`, name: t('privacypolicy') },
			],
		};
	}, [lang, city, params, isJsdom, supportLink, t, mainUrl]);

	const toggleCountry = useToggleCountryCZ();

	const handleLogo = () => {
		FILTER.resetFilter(true);
		toggleCountry();
		scrollToTop();
	};

	const currentDistrict = useSelector(getUserCurrentDistrict);
	const countrySlug = useSelector(getCountrySlug);
	const currentCity = useSelector(getUserCurrentCity);

	const selection_title = useMemo(() => {
		let title = t('selectiontitle', {
			City:
				currentCity.title +
					(currentDistrict?.id ? ` ${currentDistrict?.name}` : '') ??
				'',
			Country: `, ${region}`,
		});
		if (countrySlug) {
			title =
				t('selectionmodels', { City: '', Country: '' }) +
				' ' +
				currentCity?.title +
				(currentDistrict?.id ? ` ${currentDistrict?.name}` : '');
		}
		return title;
	}, [currentCity, currentDistrict, region, lang]);

	return (
		<footer>
			<div className="footer__container">
				<div className="logo">
					<Link
						to={mainUrl}
						title={postTitleFooter}
						onClick={() => handleLogo()}
					>
						<LogoSvg alt={t('altfooter')} />
					</Link>

					<p>
						Lady<span className={'color-green'}>4</span>Love - make
						a sensible choice
					</p>
					{
						<div className="followtelegram">
							{t('telegramfollow')}
							<br /> {t('telfol2')}
							<a
								href="https://t.me/+AUd9TM1WaDE4Mzk8"
								target="_blank"
								className="button button--primary"
							>
								<i className="icon icon-l icon--telegram"></i>
								Lady4LoveCZ
							</a>
						</div>
					}
					<div className="d-flex align-center justify-sb flex-wrap w-100">
						<a
							href="https://www.dmca.com/Protection/Status.aspx?ID=dbd4ee12-75a7-44e2-8ea5-411303819c35"
							title="http://DMCA.com  Protection Status"
							className="dmca-badge"
							target="_blank"
						>
							{' '}
							<img
								loading="lazy"
								fetchpriority="low"
								src="https://images.dmca.com/Badges/dmca-badge-w150-5x1-08.png?ID=dbd4ee12-75a7-44e2-8ea5-411303819c35"
								alt="http://DMCA.com  Protection Status"
							/>
						</a>

						<Link
							to={`/${lang}/arch`}
							title={t('arch')}
							size={'xs'}
							className={`hover ml-8`}
						>
							{t('arch')}
						</Link>
					</div>
					<p>
						{t('portaloperator')}
						{': IT4L s.r.o'}
					</p>
				</div>

				<nav className="footer-categories">
					<div className="footer__title d-flex align-center">
						<h3>{t('categories')}</h3>

						<div className="d-flex gap-8 ml-auto">
							{userType !== 'customer' && (
								<Button
									clazz={
										'add-form button button_outline--green min-w-fit'
									}
									onClick={() => {
										dispatch(
											setShowTariffsGuestPopup(true),
										);
									}}
								>
									<Icon
										style={{ fontSize: '16px' }}
										spritePath={'erocoin'}
									/>

									{t('tariffs')}
								</Button>
							)}

							{userType === 'default' && (
								<ButtonLink
									href={`/${lang}/registration#indi`}
									title={t('add')}
									size={'xs'}
									clazz={
										'add-form button--green hover min-w-fit'
									}
								>
									<Icon
										size={'l'}
										spritePath={'plus'}
									/>
									{t('add')}
								</ButtonLink>
							)}
						</div>
					</div>
					<div className="footer-categories__body">
						{categoryLinks.map((i, index) => {
							if (
								!i.disabled ||
								(location.pathname.includes('lk') &&
									(userType === 'indi' ? 'disabled' : ''))
							) {
								return (
									<a
										href={`/${lang}/${city}${i.link}`}
										key={`${i.id}_${index}`}
										title={i.title}
										className={`hover`}
										// onClick={(e) =>
										// 	footerLink(e, i.link, i.name, i)
										// }
									>
										{i.title}
									</a>
								);
							} else {
								return (
									<p
										className={'m-0 hover _disabled'}
										key={`${i.id}_${index}`}
									>
										{i.title}
									</p>
								);
							}
						})}
						<Link
							to={`/${lang}/massagebrothels`}
							title={t('massagestudios')}
							size={'xs'}
							className={`hover ${
								location.pathname.includes('lk') &&
								userType === 'indi'
									? 'disabled'
									: ''
							}`}
						>
							{t('massagestudios')}
						</Link>
						<Link
							to={`/${lang}/agencies`}
							title={t('agency')}
							size={'xs'}
							className={`hover ${
								location.pathname.includes('lk') &&
								userType === 'indi'
									? 'disabled'
									: ''
							}`}
						>
							{t('agency')}
						</Link>
						<Link
							to={`/${lang}/selection/${city}${
								currentDistrict?.id && city === 'prague'
									? `_${currentDistrict?.slug}`
									: ''
							}`}
							title={selection_title}
							size={'xs'}
							className={`hover ${
								location.pathname.includes('lk') &&
								userType === 'indi'
									? 'disabled'
									: ''
							}`}
						>
							{t('selectionmodelsFooter')}
						</Link>
					</div>
				</nav>

				<div className="footer-info">
					<p className="footer__title title_h3 d-flex">
						{t('forusers')}{' '}
						<Icon
							spritePath={'18-popup'}
							clazz="ml-auto"
						/>
					</p>
					<div className="footer-info__top-links">
						{infoLinks.top_links.map((i, index) => {
							if (i.id === 5 && userType === 'default') {
								return (
									<Link
										to={'#'}
										onClick={() => {
											dispatch(
												setAuthorisationAccessType(
													'support',
												),
											);
											dispatch(
												setAuthorizationStatus(true),
											);
											if (i.id === 1) {
												scrollToTop();
											}
										}}
										key={`${i.id}_${index}`}
										title={i.name}
										className="hover"
									>
										{i.name}
									</Link>
								);
							} else {
								return (
									<Link
										to={`${i.link}`}
										key={`${i.id}_${index}`}
										title={i.name}
										className="hover"
										onClick={() => {
											if (i.id === 101) {
												handleLogo();
											}
										}}
									>
										{i.icon ? (
											<Icon spritePath={i.icon}></Icon>
										) : (
											i.name
										)}
									</Link>
								);
							}
						})}
					</div>
					<div className="footer-info__bottom-links">
						{infoLinks.bottom_links.map((i, index) => {
							return (
								<Link
									className={'hover'}
									to={`${i.link}`}
									key={`${i.id}_${index}`}
									title={i.name}
								>
									{i.name}
								</Link>
							);
						})}
					</div>
					<div className="payment-methods">
						<div
							className="payment-methods__icon"
							title={t('czechbank')}
						>
							<Icon
								size={'m'}
								spritePath={'bank'}
							/>
						</div>

						{paymentsMethods.map((i, index) => {
							return (
								<div
									className="payment-methods__icon"
									key={index + 'pay-m'}
									title={i.name}
								>
									<Icon
										type={'payment'}
										spritePath={i.icon}
									/>
								</div>
							);
						})}
						<div
							title={'Solana'}
							className="payment-methods__icon"
						>
							<img
								className={'w-100 height-100'}
								src={solana}
								alt={'Solana'}
							/>
						</div>
					</div>
					<div className="banners-wrapper">
						<a
							rel="sponsored"
							target="_blank"
							title="Escort Sites in Europe – Most Popular in August 2024 | EroTop – Escort services in Europe"
							href="https://erotop10.com"
							className="erotop-banner"
						>
							Top-10 Escort Site
						</a>

						{/* <a
							target="_blank"
							rel="sponsored"
							title={
								lang === 'cz'
									? 'Holky na sex v Evropě - Euro Escort Directory'
									: lang === 'ru'
										? 'Каталог Эскортниц - Euro Escort Directory'
										: 'Live Sexcams: XXX Adult Shows - Free Porn Chat - Bongacams'
							}
							href="https://bongacams11.com/track?c=830668"
							className={`bonga-banner ${lang}`}
						></a> */}
						<a
							rel="sponsored"
							target="_blank"
							title={t('rbr')}
							href="https://rozkosbezrizika.cz/banner/"
							className="health-banner"
						></a>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
